// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na {\n  text-decoration: none;\n}\n.sticky-party-header {\n  position: sticky;\n  z-index: 3;\n  background-color: #F2F2F2;\n  border-bottom: solid rgba(0, 0, 0, 0.12);\n}\ntr.v-data-table__selected {\n    /* color: primary; */\n    /* color: #81D4FA; */\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
